/*  ==========================================================================
    LINKBOXES
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import 'jquery-inview';
import objectFitImages from 'object-fit-images';

// local imports
/*
 * MODULE
 */

export function initLinkBoxes($element) {

    let images = $element.find('img');
    objectFitImages(images, {
        watchMQ: true
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/linkboxes.js